import type { Confirmation } from './settingsApi';

export function confirmedOn(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function confirmedLine(confirmation: Confirmation): string {
  const when = confirmedOn(confirmation.at);
  const name = confirmation.byName?.trim();
  return name ? `Confirmed by ${name} on ${when}` : `Confirmed on ${when}`;
}
